import React from 'react';

import { useTranslation } from 'react-i18next';

import Table from '../Table';

const createLoanLink = (row) => `/loans/${row.id}?tab=Details`;

export default function BorrowerLoansTable({ rows }) {
  const { t } = useTranslation();

  const cols = [
    {
      title: t('common.tables.columns.Address'),
      keys: ['_property.address_line_1', '_property.address_line_2'],
      link: createLoanLink,
    },
    {
      title: t('common.tables.columns.City'),
      keys: ['_property.city'],
      link: createLoanLink,
    },
    {
      title: t('common.tables.columns.Zip'),
      keys: ['_property.zip'],
      link: createLoanLink,
    },
    {
      title: t('common.tables.columns.Principal Remaining'),
      keys: ['principal_remaining'],
      type: 'currency',
      link: createLoanLink,
    },
  ];

  return (
    <Table
      cols={cols}
      rows={rows}
      title="Loans"
      isFetching={false}
      minHeight={565}
    />
  );
}
